/**
 *
 * ResourceAndAssessmentDisclaimer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import ClassNames from 'classnames';
import useSiteCopySelector from 'components/useSiteCopySelector';
import AppContainer from 'components/AppContainer';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { useSelector } from 'react-redux';
import RichTextReactRenderer from '../RichTextReactRenderer';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '20px !important',
    marginTop: 33,
    boxShadow: 'none !important',
    background: '#fff',
    textAlign: 'center',
    '& p, span': {
      color: theme.palette.text.primary,
      fontSize: 12,
      lineHeight: 1.57,
    },
  },
  assessmentsDisclaimer: {
    marginTop: 33,
    border: 'none',
    [theme.breakpoints.down('600')]: {
      marginTop: 0,
    },
  },
  content: {
    boxShadow: 'none',
    '& p': {
      display: 'inline',
      margin: 0,
    },
  },
  textJustify: {
    textAlign: 'justify',
  },
  disclaimer: {
    fontWeight: 600,
  },
}));

const ResourceAndAssessmentDisclaimer = ({
  page,
  type,
  justifyText = false,
}) => {
  const classes = useStyles();
  const [disclaimer] = useSiteCopySelector([type]);
  const clientDetails = useSelector(state => state.main.clientDetails);

  const isAssessmentPage = page === 'assessments';
  if (_isEmpty(disclaimer)) return null;
  const hasCallToAction = !!_get(disclaimer, 'callToAction');
  const disclaimerJson = _isEmpty(clientDetails)
    ? _get(disclaimer, 'section1Body.json')
    : _get(disclaimer, 'body.json');
  const content = (
    <Grid
      item
      xs={12}
      className={ClassNames(
        classes.root,
        isAssessmentPage ? classes.assessmentsDisclaimer : undefined,
      )}
    >
      <Paper
        className={ClassNames({
          [classes.content]: true,
          [classes.textJustify]: justifyText,
        })}
      >
        {hasCallToAction && (
          <span className={classes.disclaimer}>
            {_get(disclaimer, 'callToAction')}&nbsp;
          </span>
        )}
        <RichTextReactRenderer data={disclaimerJson} centered />
      </Paper>
    </Grid>
  );
  if (isAssessmentPage) return content;
  return (
    <div>
      <AppContainer>{content}</AppContainer>
    </div>
  );
};

ResourceAndAssessmentDisclaimer.propTypes = {
  type: PropTypes.string,
  page: PropTypes.string,
  justifyText: PropTypes.bool,
};

export default ResourceAndAssessmentDisclaimer;
